// import { Stack, Typography } from "@mui/material";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import RemoveIcon from "@mui/icons-material/Remove";

import Form from "./Form/Form";
import Header from "./Header/Header";
import ImageScrollInfo from "./ImageScrollInfo/ImageScrollInfo";
import ImageScrollInfo2 from "./ImageScrollInfo/ImageScrollInfo2";
import ButtonNavigationSection from "./ButtonNavigationSection/ButtonNavigation";
import ScaleSection from "./ScaleSection/ScaleSection";
import ImageSides from "./SideBySide/ImageSides";
import ImportantSection from "./ImportantSection/ImportantSection";
import { ScrollProvider } from "../../Components/Hooks/useJumpSection";
import Comment from "../../Components/UI/FormInput/Comment/Comment";

function HomePage() {
  return (
    <div>
      <ScrollProvider>
        <Header />

        <Form />

        <ImageScrollInfo />

        <Comment
          title="Finally, an interface that you can depend on and operate with ease! Way
        beyond my wildest expectations. Simple, user-friendly, and reliable."
        />

        <ButtonNavigationSection />

        <Comment
          title="For someone not very tech savvy, I have had no problems and I find
            it was easy to use and navigate...I love it!"
        />

        <ImageScrollInfo2 />

        <ScaleSection />

        <ImportantSection />

        <Comment
          title="It's the go-to control system to integrate just about everything in
            my house and for automating repetitive tasks. Coupled with amazing
            media control, it's a no-brainer."
        />

        <ImageSides />

        <Comment
          title="It is so easy to run everything from one control unit. I
            particularly like the smartphone app whether I'm inside the house or
            sitting by the fire pit; I can control the music and never have to
            get up from my chair. I only wish I had done this years earlier."
        />
      </ScrollProvider>
    </div>
  );
}

export default HomePage;
